import React from 'react'
// import PropTypes from 'prop-types'
// import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Dolphin from '../../images/poolwerx-dolphin.png'

const Nav = () => {
	return (
		<header className="Nav">
			<div className="container">
				<nav className="navbar">
					<div className="navbar-brand">
						<a href="/" className="navbar-item">
							<img src={Dolphin} alt="Poolwerx Dolphin" className="logo" />
						</a>
						<div
							className="navbar-item is-hidden-desktop"
							style={{ marginLeft: 'auto' }}
						>
							<div className="buttons">
								<a
									href="https://www.poolwerx.com.au/contact-us/"
									className="button is-dark is-outlined"
								>
									<span className="icon">
										<FontAwesomeIcon icon="info-circle" />
									</span>
									<span className="is-hidden-micro">More Info</span>
									<span className="is-micro">Info</span>
								</a>
								<a
									href="https://www.poolwerx.com.au/pool-shop/"
									className="button is-dark is-outlined"
								>
									<span className="icon">
										<FontAwesomeIcon icon="shopping-cart" />
									</span>
									<span className="is-hidden-micro">Buy Now</span>
									<span className="is-micro">Buy</span>
								</a>
							</div>
						</div>
						{/* <a
							role="button"
							className="navbar-burger"
							aria-label="menu"
							aria-expanded="false"
						>
							<span aria-hidden="true" />
							<span aria-hidden="true" />
							<span aria-hidden="true" />
						</a> */}
					</div>
					<div className="navbar-menu">
						<div className="navbar-start" />
						<div className="navbar-end">
							<div className="navbar-item">
								<div className="buttons">
									<a
										href="https://www.poolwerx.com.au/contact-us/"
										className="button is-dark is-outlined"
									>
										<span className="icon">
											<FontAwesomeIcon icon="info-circle" />
										</span>
										<span>More Info</span>
									</a>
									<a
										href="https://www.poolwerx.com.au/pool-shop/"
										className="button is-dark is-outlined"
									>
										<span className="icon">
											<FontAwesomeIcon icon="shopping-cart" />
										</span>
										<span>Buy Now</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</nav>
			</div>
		</header>
	)
}

// Nav.propTypes = {}

export default Nav
